import React from 'react';
import PropTypes from 'prop-types';

import { Spinner } from '../UI';

import styles from './Charts.module.css';

const Charts = ({
    loading,
    content
  }) => (
  <div className={styles['charts-container']}>
    {!loading ? content : <Spinner size="small"/>}
  </div>
);

Charts.propTypes = {
  graph: PropTypes.array.isRequired,
  content: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

Charts.defaultProps = {
  graph: [],
};

export default Charts;
